module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAPBJREFUWEftltENAUEURc9WgA7ogApQAZ2gAi3QARVQgg4oQQk6ICeZTRb74WfeJjKTbPZlf97d++6ZmYqOV9Vxf4qA4sBfO9AHFsAQOAL3NuJyOnAGxqmx77p+05FTwBOYAxfgBhyA3acLOQXY9ArohM0V47cwB2bAOlmvCOuvldOBn3b5vxYgfqs0gn3KQugIDJzs+yhkEh3CJoaiaBBDMbRhL/21BIzadsOcITQDywaGCgrNQMFQ+7dpBIZvEz0C8fMMEMdTFxg+Ugjr01AXFBR2GNlsCijEu8Ag1WECbGQOvBmJoEIKhsWB4sCXAy+YZi0hWLyYuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertise_ui_option.png
// module id = gqHA
// module chunks = 3